import { motion } from "motion/react";
import { ReactNode } from "react";
import clsx from "clsx";

type Props = {
  onClick: () => void;
  label: string;
  icon: ReactNode;
  isActive?: boolean;
};

export default function PlayerMenuSubHeaderTab({ onClick, label, icon, isActive }: Props) {
  return (
    <button
      type="button"
      className={clsx(
        "w-full h-[2.25rem] flex items-center gap-2.5 transition-all",
        "text-12 font-extrabold hover:text-white uppercase",
        isActive ? "text-white" : "text-white/50",
      )}
      onClick={onClick}
    >
      <div className="relative w-[2.25rem] aspect-square shrink-0 flex items-center justify-center ">
        <motion.div
          animate={{
            width: isActive ? "100%" : "0",
            height: isActive ? "100%" : "0",
            opacity: isActive ? "1" : "0",
          }}
          className="z-1 absolute rounded-full bg-gradient-accent"
        />
        <div className="absolute w-[2.25rem] aspect-square bg-dark-800 rounded-full z-0" />
        {icon}
      </div>
      {label}
    </button>
  );
}
